<template>
  <!-- Header -->
  <div class="mx-auto fixed w-full z-50 bg-gray-900 bg-opacity-90 top-0 left-0">
    <div class="relative z-10 pb-4 ">
      <div class="relative pt-4 px-4 sm:px-8 lg:px-10">
        <nav
          class="relative flex items-center justify-between sm:h-10"
          aria-label="Global"
        >
          <div class="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
            <div class="flex items-center justify-between w-full md:w-auto">
              <router-link to="/">
                <img
                  class="h-10 w-auto sm:h-12"
                  alt="Samply Logo"
                  src="./assets/logo-horizontal.svg"
                />
              </router-link>
            </div>
          </div>
          <div class="space-x-4 sm:block sm:ml-10 md:pr-4 sm:space-x-2">
            <router-link to="/pricing">
              <AnchorButton href="" size="small" @click="pricingEvent()">
                Pricing
              </AnchorButton>
            </router-link>
            <AnchorButton
              :href="appURL"
              size="small"
              primary
              @click="onCTA('Sign up')"
            >
              Sign up
            </AnchorButton>
          </div>
        </nav>
      </div>
    </div>
  </div>
  <!-- Main content -->

  <router-view class="text-white pt-16 sm:pt-32" v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component v-if="!loading" :is="Component" />
    </transition>
  </router-view>

  <footer
    class="flex align-middle justify-end text-xs font-light text-white text-opacity-50 md:text-sm px-4 sm:px-8 py-3 sm:py-6"
  >
    <div>
      &copy; {{ new Date().getFullYear() }}
      <b class="font-semibold">Samply, Inc.</b> All Rights Reserved
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AnchorButton from "@/components/AnchorButton.vue";
import amplitude from "amplitude-js";
import * as config from "@/plugins/remote-config";

export default defineComponent({
  name: "App",
  components: {
    AnchorButton
  },
  setup() {
    const deviceId = amplitude.getInstance().options.deviceId;
    const APP_URL =
      process.env.VUE_APP_ENDPOINTS === "production"
        ? `https://samply.app/?deviceid=${deviceId}`
        : `https://staging.samply.app/?deviceid=${deviceId}`;
    amplitude.getInstance().logEvent("[Website] Visited Landing Page");
    amplitude.getInstance().logEvent("[Website] Visited Landing Page");
    return {
      appURL: APP_URL
    };
  },
  methods: {
    onCTA(buttonText: string) {
      amplitude.getInstance().logEvent("[Website] Clicked CTA", { buttonText });
    },
    pricingEvent() {
      amplitude.getInstance().logEvent("[Website] Clicked Pricing");
    }
  },
  computed: {
    loading(): boolean {
      return !config.state.activated;
    }
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
